// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f2615fef","610":"262ef63e","703":"720d7844","787":"c041df7a"}[chunkId] + ".chunk.js";
};